import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-logout\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M3.5,22a1,1,0,0,1-1-1V3a1,1,0,0,1,1-1h14a1,1,0,0,1,1,1V6h-2V4H4.5V20h12V18h2v3a1,1,0,0,1-1,1Zm13-6V13h-7V11h7V8l5,4Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol